import { FC, createContext, useContext, useState, ReactNode } from 'react';

interface StorePickupPackageContextType {
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
    setIsCargoCompanySelected: (isCargoCompanySelect: boolean) => void;
    isCargoCompanySelected: boolean;
    cargoCompany: number | string | undefined;
    setCargoCompany: (cargoCompany: string | number | undefined) => void;
    packageList: any[] | null;
    setPackageList: (packageList: any[] | null) => void;
    damagedRows: any[];
    setDamagedRows: (damagedRows: any) => void;
    scannedRows: any[];
    setScannedRows: (scannedRows: any) => void;
    dPackageCargoShipmentCode: string;
    setDPackageCargoShipmentCode: (dPackageCargoShipmentCode: string) => void;
}

const StorePickupPackageContext = createContext<StorePickupPackageContextType | undefined>(undefined);

export const StorePickupPackageProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isCargoCompanySelected, setIsCargoCompanySelected] = useState<boolean>(false);
    const [cargoCompany, setCargoCompany] = useState<string | number | undefined>();
    const [packageList, setPackageList] = useState<any[] | null>(null);
    const [damagedRows, setDamagedRows] = useState<any[]>([]);
    const [scannedRows, setScannedRows] = useState<any[]>([]);
    const [dPackageCargoShipmentCode, setDPackageCargoShipmentCode] = useState<string>('');

    return (
        <StorePickupPackageContext.Provider
            value={{
                isLoading,
                setIsLoading,
                isCargoCompanySelected,
                setIsCargoCompanySelected,
                cargoCompany,
                setCargoCompany,
                packageList,
                setPackageList,
                damagedRows,
                setDamagedRows,
                scannedRows,
                setScannedRows,
                dPackageCargoShipmentCode,
                setDPackageCargoShipmentCode,
            }}
        >
            {children}
        </StorePickupPackageContext.Provider>
    );
};

export const useStorePickupPackageContext = () => {
    const context = useContext(StorePickupPackageContext);
    if (!context) {
        throw new Error('useStorePickupPackageContext must be used within a StorePickupPackageProvider');
    }
    return context;
};
